import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";
import { darTimeoutOptionsList } from "@/react/features/vcc/agent-groups/utils/darTimeoutOptions";
export const AGUI_EXPERIENCE_AGENT_CONSOLE = "classic";
export const AGUI_EXPERIENCE_AGENT_WORKSPACE = "performance";
export const AGUI_EXPERIENCE_TOGGLE = "toggle";

export const AGENT_FIRST_NAME = "first_name";
export const AGENT_AGENT = "agent";

export const PHONE_ON_DEMAND = "on-demand";
export const PHONE_PERSISTENT = "persistent";

const schema = yup.object({
  id: yup.number().nullable(),
  name: yup
    .string()
    .matches(
      /^[^&><~;\\]+$/,
      "${label} should not contain special characters (&, <, >, ~, ;)"
    )
    .max(180)
    /** @see schemaFields.js */
    .unique()
    .required(),
  comment: yup.string().nullable().max(250),
  outbound_phone_code_list: yup
    .object({
      name: yup.string().nullable(),
      id: yup.string().nullable(),
    })
    .nullable(),
  default_agent_display_name: yup
    .string()
    .nullable()
    .oneOf([AGENT_FIRST_NAME, AGENT_AGENT]),
  phone_connection_mode: yup
    .string()
    .nullable()
    .oneOf([PHONE_ON_DEMAND, PHONE_PERSISTENT]),
  status_code_list: yup
    .object({
      name: yup.string(),
      id: yup.string(),
    })
    .nullable(),
  agent_count: yup.number().nullable(),
  is_assigned: yup.boolean().nullable(),
  edit_agent_display_name_enabled: yup.boolean().nullable(),
  agent_recordings_enabled: yup.boolean().nullable(),
  resolved_display_customer_cli_enabled: yup.boolean().nullable(),
  display_customer_cli_enabled: yup.boolean().nullable(),
  is_default: yup.boolean().nullable(),
  agent_reject_enabled: yup.boolean().nullable(),
  change_phone_connection_mode: yup.boolean().nullable(),
  auto_answer_enabled: yup.boolean().nullable(),
  dar_timeout: yup
    .string()
    .nullable()
    .oneOf(darTimeoutOptionsList.map((item) => item.value)),
  agui_mode: yup
    .string()
    .nullable()
    .oneOf([
      AGUI_EXPERIENCE_AGENT_CONSOLE,
      AGUI_EXPERIENCE_AGENT_WORKSPACE,
      AGUI_EXPERIENCE_TOGGLE,
    ]),
});

addKeyToFieldsRecursively(schema);

export default schema;
